import { render, staticRenderFns } from "./DirectManagerDashboardOverview.vue?vue&type=template&id=ef417b82&"
import script from "./DirectManagerDashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DirectManagerDashboardOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports